import dashboard from './groups/dashboard'
import login from './groups/login'
import operations from './groups/operations'
import portalContent from './groups/portalContent'
import registry from './groups/registry'
import reports from './groups/reports'
import shell from './groups/shell'
import transactions from './groups/transactions'

/**
 * The text catalogue.
 *
 * One file per screen or area, so several people can convert screens in
 * parallel without touching the same file. Defaults live here, in code, and the
 * database holds only overrides — which is what keeps the portal readable when
 * the override request fails.
 */
export const GROUPS = [
  shell,
  login,
  dashboard,
  transactions,
  reports,
  registry,
  operations,
  portalContent,
]

export const DEFAULTS = GROUPS.reduce((all, group) => {
  for (const [key, text] of Object.entries(group.texts)) all[key] = text
  return all
}, {})
